import * as React from "react";

const PhoneLineIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.6 21c-1.9 0-3.9-.7-5.9-2a24.3 24.3 0 0 1-6.7-6.7C1.7 10.2 1 8.2 1 6.3c0-.5.2-1 .6-1.4l2.2-2.2c.5-.4 1.2-.4 1.6.1l2.5 3c.4.5.4 1.1 0 1.6L6.3 9c1 1.9 2.8 3.7 4.7 4.7l1.6-1.6c.5-.4 1.1-.4 1.6 0l3 2.5c.5.4.5 1.1.1 1.6l-2.2 2.2c-.4.4-.9.6-1.5.6Z" />
  </svg>
);

export default PhoneLineIcon;
